import {
   FORM_LOADER,
   UPDATE_LOADER,
   RESET_LOADERS
} from '../constants';
const INIT_STATE = {
  formIds:{},
  completed:{},
  response:{}
};

export default (state = INIT_STATE, action) => {
  var formId;
  var formIds = {...state.formIds};
  var response = {...state.response};
  if (action && action.payload){
  var stateRefresh = (action.payload) ? action.payload : action;
      if ((stateRefresh.response && stateRefresh.response.id)){
        formId = (stateRefresh.payload && stateRefresh.payload.formId) ? stateRefresh.payload.formId : new Date().getTime(); 
          formIds[formId] = false;
          response[formId] = stateRefresh.response;
      }else{
        var formBool = action.payload.status ? action.payload.status : true;
        formId = action.payload.formId;
        formIds[formId] = formBool;
        delete response[formId];
      }
    }
    Object.keys(response).map((ro)=>{
      if (response[ro].complete){
        delete response[ro];
        delete formIds[ro];
      }else{
        response[ro].complete = true;
      }
    })
  switch (action.type) { 
    case "error":
      return { 
               formIds,
               response

      };
    break;
    case "RESET_LOADERS":
      var ids = {...state.formIds};
      var rids = {...state.response};
      for (var p of Object.keys(formIds)){
        delete ids[p];
        delete rids[p];
      }
      return {
          formIds:{},
          completed:{},
          response:{}
      }
      break;
      case "FORM_LOADER":
        return { 
          ...state,
        formIds,
        response
      };
        break;
      case "UPDATE_LOADER":
        var ids = {...state.formIds};
        if (action && action.payload && action.payload.hasOwnProperty("status")){
            ids[action.payload.id] = action.payload.status;
        }
        return { 
          ...state,
          formIds:{...ids}
  };
      break;
    default:
     
      return { 
        formIds,
        response
};
    break;
  }
};
